import { mediaQueryUp } from 'components/utils/breakpoint'
import { getImageUrl } from 'lib/image/imageUtils'
import { rem } from 'polished'
import styled from 'styled-components'

const Background = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
  background:
    url(${getImageUrl('lux-plus-month-plus-texture-mobile')}) repeat-x top center / 100%,
    linear-gradient(40deg, rgb(12, 21, 110) 0%, 9.80149%, rgb(15, 20, 118) 19.603%, 24.1522%, rgb(18, 21, 138) 28.7014%, 29.694%, rgb(23, 24, 145) 30.6865%, 34.4086%, rgb(32, 33, 153) 38.1307%, 41.5633%, rgb(27, 30, 155) 44.9959%, 51.4888%, rgb(25, 35, 167) 57.9818%, 60.091%, rgb(32, 44, 174) 62.2002%, 63.6476%, rgb(42, 54, 180) 65.0951%, 68.4036%, rgb(54, 69, 190) 71.7122%, 78.7014%, rgb(64, 84, 203) 85.6907%, 92.8453%, rgb(72, 102, 222) 100%);

  ${mediaQueryUp.tablet} {
    background:
      url(${getImageUrl('lux-plus-month-plus-texture-desktop')}) top center / ${rem(1440)},
      radial-gradient(100% 101.45% at 0% 1.74%, #4866DE 0%, #4054CB 16.37%, #3645BE 24.83%, #2A36B4 33.74%, #202CAE 41.88%, #1923A7 47.59%, #1B1E9B 55%, #202199 61.87%, #171891 69.31%, #12158A 79.48%, #0F1476 89.22%, #0C156E 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;
  }
`

interface Props {
  className?: string
}

function LuxPlusExperienceDiscountTakeoverBackground({ className }: Props) {
  return <Background className={className}>
  </Background>
}

export default LuxPlusExperienceDiscountTakeoverBackground
